
    import CompanyLogo from '@/components/Company/CompanyLogo';
    import JobViewMixin from '~/components/JobView/Mixins/JobViewMixin.vue';

    export default {
        name: 'JobViewBrandVisual',

        components: {
            CompanyLogo,
        },

        mixins: [JobViewMixin],

        props: {
            logoPosition: {
                type: String,
                default: 'center',
            },
        },

        data() {
            return {
                isCompanyTextActive: false,
            };
        },

        computed: {
            primaryBrandColor() {
                return this.$_companyPrimaryColor || 'var(--primary500)';
            },

            logoPositionClass() {
                const positions = {
                    left: 'left-3',
                    center: 'left-auto right-auto',
                    right: 'right-3',
                };

                return positions[this.logoPosition];
            },
        },
    };
